import { LEARN_LAUNCH_CONFIG } from '@/constants/learnLaunchConfig';
import { AdvancedToolGateScreen } from '@/features/unified-learning/runtime/components/AdvancedToolGateScreen';
import { ReverseLearningEntryScreen } from '@/features/unified-learning/runtime/screens/ReverseLearningEntryScreen';

export default function LearnReverseEntryRoute() {
  if (!LEARN_LAUNCH_CONFIG.advancedTools.reverse) {
    return <AdvancedToolGateScreen tool="reverse" />;
  }
  return <ReverseLearningEntryScreen />;
}
